export const normalizeNumber = (value: unknown): number => Number(value) || 0;
